import React, { useState } from 'react';
import VideoUploader from 'components/inputs/video/VideoUploader';
import HLSPlayer from 'routes/video/HLSPlayer';

const VideoUploadTestPage = () => {
    const [videoUrl, setVideoUrl] = useState(null);
    const [isProcessing, setIsProcessing] = useState(false);

    const handleUploadComplete = (url) => {
        setVideoUrl(url);
        setIsProcessing(false);
    };

    return (
        <div className="video-page">
            <h1>비디오 업로드</h1>

            <VideoUploader
                basePath="test"
                onUploadStart={() => setIsProcessing(true)}
                onUploadComplete={handleUploadComplete}
            />
            {/* <HLSPlayer
                src="https://puffuapp.com/api/open/videos/test/2025/3/20250323090218304/index.m3u8"
                autoPlay={false}
                controls={true}
                width="100%"
                height="auto"
            /> */}

            {videoUrl && (
                <div className="video-player-container">
                    <h2>업로드된 비디오</h2>
                    <HLSPlayer
                        src={videoUrl}
                        autoPlay={false}
                        controls={true}
                        width="100%"
                        height="auto"
                    />
                </div>
            )}

            {isProcessing && !videoUrl && (
                <div className="processing-message">
                    비디오 처리 중... 잠시만 기다려 주세요.
                </div>
            )}
        </div>
    );
};

export default VideoUploadTestPage;